import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  isAllElementsOfSearchTextNotExist,
  mapSearchText,
} from '../../../../libs/utils'
import { UserGroup, UserGroupsRequest, UserGroupsResponse } from './types'

export const groupsListMounted = createEvent<UserGroupsRequest | undefined>()

export const getUserGroups = fx<UserGroupsRequest, UserGroupsResponse>({
  method: 'GET',
  url: `/user_group`,
})

export const $userGroups = restore<UserGroup[]>(
  getUserGroups.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfUserGroups = restore(
  getUserGroups.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: groupsListMounted,
  fn: (params) => {
    if (!params) {
      return
    }

    let { limit, page, orderBy, orderDirection, searchText, filters } = params

    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      const filtersValue = filters

      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filtersValue[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] = `${
            filtersValue[key as keyof typeof filters]
          }`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getUserGroups,
})
